
  import { css } from 'lit';
  export const styles = css`:host{--component-size: var(--ig-size, var(--default-size));--button-min-width: 2.625rem}[part~=group]{box-shadow:var(--elevation);border-radius:var(--border-radius)}:host([alignment=horizontal]){--horizontal-radius: var(--border-radius)}:host([alignment=vertical]){--vertical-radius: var(--border-radius)}`;
  